import type { OutputFileFormat } from '@libs/enums';
import type { OutputOperations } from '@libs/templates/mst';
import type { Characters, Item } from '@ps-smart-cp/ppfw-client';
import { FieldSet, TextStringField } from '@ps-smart-cp/ppfw-client';

interface Props<I extends Record<'jobComment', Item<Characters>>> {
  obj: OutputOperations;
  setObj: (obj: OutputOperations) => void;
  items: I;
  enumParams: OutputFileFormat[];
}

export function OutputOps<I extends Record<'jobComment', Item<Characters>>>({
  obj,
  setObj,
  items,
}: Props<I>) {
  return (
    <FieldSet>
      {/* pdfがスコープアウトされるかどうかが決まる前に、ファイル形式のFieldをコメントアウトする */}
      {/* <CheckboxGroupField
        title="出力ファイル形式"
        obj={obj}
        setObj={setObj}
        prop="outputFileFormat"
        enumType={OutputFileFormat}
        required
      /> */}
      <TextStringField obj={obj} setObj={setObj} prop="jobComment" items={items} />
    </FieldSet>
  );
}
